import { motion } from 'framer-motion';
import type { CodeRedemption } from '../../lib/partner-dashboard';

interface CodeRedemptionRateProps {
  data: CodeRedemption;
  locale?: string;
}

export function CodeRedemptionRate({ data, locale }: CodeRedemptionRateProps) {
  const tr = locale === 'tr';
  const circumference = 2 * Math.PI * 54;
  const strokeDashoffset = circumference - (data.rate / 100) * circumference;

  const rateColor = data.rate >= 70
    ? 'text-success-40'
    : data.rate >= 40
    ? 'text-orange-40'
    : 'text-destructive-40';

  const strokeColor = data.rate >= 70
    ? 'rgba(155, 177, 103, 1)'
    : data.rate >= 40
    ? 'rgba(251, 146, 60, 1)'
    : 'rgba(251, 113, 133, 1)';

  return (
    <div className="freud-card-elevated p-6">
      <h3 className="text-text-xl text-gray-80 mb-4">{tr ? 'Kod Kullanimi' : 'Code Redemption'}</h3>
      <div className="flex flex-col items-center">
        <div className="relative w-32 h-32 mb-4">
          <svg className="w-full h-full -rotate-90" viewBox="0 0 120 120">
            <circle
              cx="60"
              cy="60"
              r="54"
              stroke="rgba(235, 226, 214, 1)"
              strokeWidth="8"
              fill="none"
            />
            <motion.circle
              cx="60"
              cy="60"
              r="54"
              stroke={strokeColor}
              strokeWidth="8"
              fill="none"
              strokeLinecap="round"
              strokeDasharray={circumference}
              initial={{ strokeDashoffset: circumference }}
              animate={{ strokeDashoffset }}
              transition={{ duration: 1, ease: 'easeOut' }}
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className={`text-heading-sm font-bold ${rateColor}`}>
              {data.rate}%
            </span>
          </div>
        </div>
        <div className="flex gap-6 text-center">
          <div>
            <div className="text-text-xl text-gray-80">{data.usedCodes}</div>
            <div className="text-text-xs text-gray-40">{tr ? 'Kullanilan' : 'Used'}</div>
          </div>
          <div className="w-px bg-gray-20" />
          <div>
            <div className="text-text-xl text-gray-80">{data.totalCodes}</div>
            <div className="text-text-xs text-gray-40">{tr ? 'Toplam' : 'Total'}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
